import { render, staticRenderFns } from "./scoringCriteria.vue?vue&type=template&id=1a97bea6&scoped=true&"
import script from "./scoringCriteria.vue?vue&type=script&lang=js&"
export * from "./scoringCriteria.vue?vue&type=script&lang=js&"
import style0 from "./scoringCriteria.vue?vue&type=style&index=0&id=1a97bea6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a97bea6",
  null
  
)

export default component.exports